import { createTheme } from "@mui/material";
import { red, yellow } from "@mui/material/colors";
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    iconButton: true;
  }
}
// A custom theme for this app
const theme = createTheme({
  typography: {
    button: {
      textTransform: "none",
    },
  },

  palette: {
    primary: {
      main: "#005ECC",
      contrastText: "#fff",
    },
    secondary: {
      main: "#0EAFCC",
      contrastText: "#fff",
    },
    success: {
      main: "#28a745",
      contrastText: "#fff",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: "iconButton" },
          style: {
            backgroundColor: "#E5EFFA",
            color: "#005ECC",
            "&:hover": {
              backgroundColor: "#CED7E0",
              color: "#005ECC",
            },
            contrastText: "#ffffff",
          },
        },
      ],
      styleOverrides: {
        root: {
          backgroundColor: "#005ECC",
          height: "36px",
          "&:hover": {
            backgroundColor: "#0075FF",
          },
        },
      },
      },
      MuiTextField: {
          styleOverrides: {
              root: {
                  
                  '& .MuiOutlinedInput-root': {
                      backgroundColor: 'transparent',
                      marginTop: '8px',
                      marginBottom: '16px',
                      borderRadius: "8px",
                      height: "36px",
                      // Reset height for Autocomplete inputs specifically
                      '&.MuiAutocomplete-inputRoot': {
                          height: "auto",
                          minHeight: "36px",
                      },
                      '& .MuiSelect-select': {
                          padding: '8px 32px 8px 14px',
                          lineHeight: '20px',
                          minHeight: 'auto',
                      },
                      '& fieldset': {
                          borderColor: '#e0e0e0',
                      },
                      '&:hover fieldset': {
                          borderColor: '#005ECC',
                      },
                      '&.Mui-focused fieldset': {
                          borderColor: '#005ECC',
                      },
                      
                      '@media (prefers-color-scheme: dark)': {
                          backgroundColor: '#3A4142',
                          color: '#000000',
                          '& fieldset': {
                              borderColor: '#555555',
                          },
                          '&:hover fieldset': {
                              borderColor: '#93CDFD',
                          },
                          '&.Mui-focused fieldset': {
                              borderColor: '#93CDFD',
                          },
                          '& input': {
                              color: '#ffffff',
                          },
                          '& .MuiSelect-select, & .MuiSelect-icon': {
                              color: '#ffffff',
                          },
                      },
                  },
              },
          },
      },
      MuiAutocomplete: {
          styleOverrides: {
              root: {
                  '& .MuiOutlinedInput-root': {
                      height: "36px !important",
                      display: "flex",
                      alignItems: "center",
                  },
              },
              inputRoot: {
                  height: "36px !important",
                  display: "flex !important",
                  alignItems: "center !important",
                  padding: "0 !important",
                  '& .MuiInputBase-input': {
                      padding: '8px 14px !important',
                      height: "auto !important",
                      lineHeight: "20px",
                  },
              },
              input: {
                  padding: "8px 14px !important",
                  height: "auto !important",
                  lineHeight: "20px",
              },
          },
      },
  },

});

export default theme;
